import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'localization';
import { EmptyStateAtom } from 'design-system/my-lib';
import { useStudioMode } from './StudioMode';
import './StudioModePlaceholder.scss';

/**
 * Operator/author home (spec SC8, UI Components table) — an honest placeholder naming what the
 * mode will become rather than fabricating desk content. Only ever mounted for `operator`/
 * `author`; `platform` mode routes to `StudioDeskPage`.
 */
const StudioModePlaceholder: React.FC = () => {
  const { t } = useTranslation();
  const { mode } = useStudioMode();
  const modeKey = mode === 'platform' ? 'author' : mode;

  return (
    <div className="studio-mode-placeholder" data-testid={`studio-mode-placeholder-${modeKey}`}>
      <header className="studio-mode-placeholder__header">
        <h1 className="studio-mode-placeholder__title">
          {t(`studio.mode.placeholder.${modeKey}.title`)}
        </h1>
      </header>
      <EmptyStateAtom
        icon="pi-hourglass"
        title={t(`studio.mode.placeholder.${modeKey}.emptyTitle`)}
        description={t(`studio.mode.placeholder.${modeKey}.emptyDescription`)}
      />
      <Link className="studio-mode-placeholder__platform-link" to="/studio?as=platform">
        {t('studio.mode.placeholder.platformLink')}
      </Link>
    </div>
  );
};

export default StudioModePlaceholder;
